module.exports = "/matchcenter-staging/assets/images/matchcenter_search_delete.2d303f788cb9d1062f990f9cc54644e4.svg";